import {motion} from 'framer-motion'
import {useState, useEffect} from 'react'
import {interpolate} from 'flubber'

const openIcon = [
  'M1 2C1 1.44772 1.44772 1 2 1H4C4.55228 1 5 1.44772 5 2V4C5 4.55228 4.55228 5 4 5H2C1.44772 5 1 4.55228 1 4V2Z',
  'M1 8C1 7.44772 1.44772 7 2 7H4C4.55228 7 5 7.44772 5 8V10C5 10.5523 4.55228 11 4 11H2C1.44772 11 1 10.5523 1 10V8Z',
  'M7 2C7 1.44772 7.44772 1 8 1H10C10.5523 1 11 1.44772 11 2V4C11 4.55228 10.5523 5 10 5H8C7.44772 5 7 4.55228 7 4V2Z',
  'M7 8C7 7.44772 7.44772 7 8 7H10C10.5523 7 11 7.44772 11 8V10C11 10.5523 10.5523 11 10 11H8C7.44772 11 7 10.5523 7 10V8Z',
]

const closeIcon = [
  'M0.851562 1C0.851562 0.447715 1.29928 0 1.85156 0H3.85156C4.40385 0 4.85156 0.447715 4.85156 1V3C4.85156 3.55228 4.40385 4 3.85156 4H1.85156C1.29928 4 0.851562 3.55228 0.851562 3V1Z',
  'M0.851562 9C0.851562 8.44772 1.29928 8 1.85156 8H3.85156C4.40385 8 4.85156 8.44772 4.85156 9V11C4.85156 11.5523 4.40385 12 3.85156 12H1.85156C1.29928 12 0.851562 11.5523 0.851562 11V9Z',
  'M4.92969 5C4.92969 4.44772 5.3774 4 5.92969 4H7.92969C8.48197 4 8.92969 4.44772 8.92969 5V7C8.92969 7.55228 8.48197 8 7.92969 8H5.92969C5.3774 8 4.92969 7.55228 4.92969 7V5Z',
  'M9.14844 1C9.14844 0.447715 9.59615 0 10.1484 0H12.1484C12.7007 0 13.1484 0.447715 13.1484 1V3C13.1484 3.55228 12.7007 4 12.1484 4H10.1484C9.59615 4 9.14844 3.55228 9.14844 3V1Z',
  'M9.14844 9C9.14844 8.44772 9.59615 8 10.1484 8H12.1484C12.7007 8 13.1484 8.44772 13.1484 9V11C13.1484 11.5523 12.7007 12 12.1484 12H10.1484C9.59615 12 9.14844 11.5523 9.14844 11V9Z',
]

export const MorphicDropdownToggleSVG = ({isOpen}: {isOpen: boolean}) => {
  const [currentPaths, setCurrentPaths] = useState(openIcon)

  // Toggle animation
  useEffect(() => {
    const maxLength = Math.max(openIcon.length, closeIcon.length)
    const fromPaths = isOpen ? openIcon : closeIcon
    const toPaths = isOpen ? closeIcon : openIcon

    const interpolators = Array.from({length: maxLength}).map((_, idx) => {
      const from = fromPaths[idx] || 'M0 0Z'
      const to = toPaths[idx] || 'M0 0Z'
      return interpolate(from, to)
    })

    let animationFrame: number
    let progress = 0

    const animate = () => {
      progress += 0.1

      if (progress > 1) {
        progress = 1
      }

      setCurrentPaths(interpolators.map((interp) => interp(progress)))

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate)
      }
    }

    animate()

    return () => cancelAnimationFrame(animationFrame)
  }, [isOpen])

  return (
    <svg
      width={14}
      height={14}
      viewBox={isOpen ? '0 0 14 12' : '0 0 12 12'}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%]"
    >
      {currentPaths.map((d, idx) => (
        <motion.path key={idx} d={d} initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} />
      ))}
    </svg>
  )
}
